export type PhotoFlowEvent =
  | 'PHOTO_PICK_START'
  | 'PHOTO_PICK_FILE_RECEIVED'
  | 'PHOTO_MIME'
  | 'PHOTO_SIZE'
  | 'PHOTO_READ_RETRY_SUCCESS'
  | 'PHOTO_DECODE_START'
  | 'PHOTO_DECODE_SUCCESS'
  | 'PHOTO_DECODE_FAIL'
  | 'PHOTO_PERSIST_START'
  | 'PHOTO_PERSIST_SUCCESS'
  | 'PHOTO_PERSIST_FAIL'
  | 'PHOTO_ID'
  | 'DESIGN_SELECTED'
  | 'EDITOR_IMAGE_RESTORE_START'
  | 'EDITOR_IMAGE_RESTORE_SUCCESS'
  | 'EDITOR_IMAGE_RESTORE_FAIL'
  | 'OBJECT_URL_CREATED'
  | 'OBJECT_URL_REVOKED'
  | 'TRYON_REDIRECT'
  | 'TRYON_REDIRECT_REASON';

type SafePhotoMetadata = Record<string, string | number | boolean | undefined>;

function safeValue(value: string | number | boolean | undefined): string | number | boolean | undefined {
  if (typeof value !== 'string') return value;
  return value.replace(/[^A-Za-z0-9_./:+-]/g, '_').slice(0, 96);
}

/** Privacy-safe client diagnostics: never pass file names, URLs, bytes, or image content. */
export function logPhotoFlow(event: PhotoFlowEvent, metadata: SafePhotoMetadata = {}): void {
  const safeMetadata = Object.fromEntries(Object.entries(metadata)
    .filter(([, value]) => value !== undefined && ['string', 'number', 'boolean'].includes(typeof value))
    .map(([key, value]) => [key.slice(0, 48), safeValue(value)]));
  console.debug('[WALLD photo flow]', event, safeMetadata);
}
